
import './App.css';
// import Amplify from 'aws-amplify';
// import awsconfig from './aws-exports';

import React, {Component} from 'react';
import {BrowserRouter, Switch, Route, Routes, Link, HashRouter} from "react-router-dom";
import { Button, Navbar, Nav, NavDropdown, Form, FormControl, Badge, InputGroup } from 'react-bootstrap';
//import 'bootstrap/dist/css/bootstrap.min.css';


import UrlParameter from './urlParameter';


//Amplify.configure(awsconfig)


// Class definition.
class App extends Component{
  
  render(){

   return(
      <div className="App">            
          {/* <BrowserRouter>
              <Route path="/:url" component={UrlParameter}></Route>
          </BrowserRouter> */}

          {/*Why we need HashRouter:    https://stackoverflow.com/questions/66326106/react-router-locations-on-aws-s3-bucket-do-not-work*/}
          <HashRouter>
              <Routes>
                <Route path="/:url" element={<UrlParameter/>}></Route>
              </Routes>
          </HashRouter>
      </div>
    )
  }
}

export default App;
